// extracted by mini-css-extract-plugin
export var banner = "_eh-0";
export var closeButton = "_eh-2";
export var greenCheckmark = "_eh-3";
export var hereLink = "_eh-4";
export var titleIcon = "_eh-1";